export default __webpack_public_path__ + "static/media/dj2.e93bd04a.jpg";